import { PropsWithChildren } from "react";
import { Button, Modal } from "react-bootstrap";

interface ReadonlyFormModalProps extends PropsWithChildren {
    show: boolean;
    onHide: () => void;
    title: string;
    onDownload: () => void;
    sendEmailText?: string;
    onSendEmail?: () => void;
}

export function ReadonlyFormModal({
    show,
    onHide,
    title,
    onDownload,
    children,
    sendEmailText,
    onSendEmail,
}: Readonly<ReadonlyFormModalProps>) {
    return (
        <Modal show={show} onHide={onHide} centered size="xl" backdrop="static">
            <Modal.Header closeButton>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="max-70-vh">{children}</Modal.Body>
            <Modal.Footer className="d-flex justify-content-between">
                <Button onClick={onHide} variant="secondary">
                    Close
                </Button>
                <div>
                    <Button onClick={onDownload}>Download</Button>
                    {onSendEmail && (
                        <Button onClick={onSendEmail} style={{ marginLeft: "8px" }}>
                            {sendEmailText ?? "Send"}
                        </Button>
                    )}
                </div>
            </Modal.Footer>
        </Modal>
    );
}
